import { Suspense, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';

import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';

import { openWidget } from '#src/components/Form/index.tsx';
import { Layout } from '#src/components/Layout/index.tsx';
import { NEW_REQUEST_HASH } from '#src/constants/routes.ts';

const HelpCenterLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === NEW_REQUEST_HASH) {
      openWidget();
      navigate(location.pathname, { replace: true });
    }
  }, [location.hash, location.pathname, navigate]);

  return (
    <Layout>
      <Suspense fallback={<LoadingIndicator fullHeight />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

export default HelpCenterLayout;
